import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RgsRegistrazione } from '../objects/rgsRegistrazione';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService{
  endpoint: string;
  apiName:string='RgsRegistrazione';

  constructor( protected http: HttpClient, protected appConfigService:AppConfigService)
  {
    this.http=http;
    this.endpoint = appConfigService.apiBaseUrl;
  }


  getFirst(serialNumberMs:number): Observable<RgsRegistrazione> {
    //this.loading = true;

    console.log(this.apiName);
    return this.http.get<RgsRegistrazione>(`${this.endpoint}/${this.apiName}?serialMS=${serialNumberMs}`);
  }
}